import * as React from 'react';
import formatNumber from './../../utilities/format-number';

interface Props {
    isRoundInterval: boolean;
    roundScores: RoundScore[][];
}

export default class RoundResults extends React.Component<Props, {}> {

    render(): JSX.Element | null {

        if (this.props.isRoundInterval) {

            const { roundScores } = this.props;
            const scores = roundScores[roundScores.length - 1]
                .map(function (roundScoreDetail: RoundScore, index: number): JSX.Element {
                    return (
                        <td key={index}>
                            {roundScoreDetail.label}
                            <span>+{formatNumber(roundScoreDetail.score)}</span>
                        </td>
                    );
                });

            return (
                <div className="quiz-scores">
                    <table>
                        <tbody>
                            <tr>{scores}</tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return null;
        }
    }
    
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/globals/components/scores/scores.tsx